import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  Fragment,
} from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import moment from "moment";
import _ from "lodash";
import Grid from "@material-ui/core/Grid";
import Header from "../../components/Header";
import AddCommunityMemberModal from "../../components/AddCommunityMemberModal";
import AddDemoUserModal from "../../components/AddDemoUserModal";
import Firebase from "../../firebasehelper";
import { inviteUserSMS } from "../../functions/Twilio";
import UserTokenLedgerModal from "../../components/UserTokenLedgerModal";
import AddTokenLedgerModal from "../../components/AddTokenLedgerModal";
import ManifestModal from "./ManifestModal";
import ScheduleModal from "../CalendarHub/ScheduleModal";
import AddNoteModal from "../../components/AddNoteModal";
import { alertAppointment } from "../../functions/Twilio";
import { getDayStr } from "../../functions/index";
import PDFViewerModal from "../../components/PDFViewer";
import Button from "./Button";
import { saveBrand } from "../../redux/actions";
// import useDebounce from "../../hooks/useDebounce";
import { user_access } from "../../Constants/selections";
// import { idealTextColor } from "../../functions/index";
// import { CSVLink } from "react-csv";
import InfiniteScroll from "react-infinite-scroll-component";
import "./index.css";
import useWindowSize from "../../hooks/useWindowSize";
import ConfirmationModal from "../../components/ConfirmationModal";

const user_icon = require("../../assets/media/user.png");

const usersJson = [];

// const csvHeaders = [
//   { label: "First Name", key: "firstname" },
//   { label: "User Type", key: "userType" },
//   { label: "User Categorisation", key: "userCategorisation" },
//   { label: "Account Manager", key: "accountManager" },
//   { label: "Lead Internal ID", key: "leadInternalID" },
//   { label: "Ecosystem UID", key: "uid" },
//   { label: "Ecosystem Magic Link", key: "ecosystemMagicLink" },
// ];

const UserItem = React.memo(
  ({ item, onClickItem, onCopyUID, onRemoveUser, agencies }) => {
    // may be expensive but I doubt anyone would keep resizing their screen
    const dimensions = useWindowSize();

    const getStatus = () => {
      if (item.status === "Pending") return "Inactive";
      if (!item.phonenumber) return "Light";
      if (item.eco_id) return "Full";
      if (item.phonenumber && !item.eco_id) return "Pending";
    };
    const currentAgency = agencies.find(
      (agency) => agency.uid === item.accountant
    );

    return (
      <div key={item.id} className="member-row bottom-line">
        <Grid container className="member-row__container">
          <Grid item className="field__name">
            <div className="profile-field profile-field__name">
              <img
                src={item.avatar_url || user_icon}
                className="avatar"
                alt="icon"
              />
              <p>
                {item.firstname &&
                  item.firstname.replace(" ", "-").slice(0, 14)}
              </p>
            </div>
          </Grid>
          <Grid item className="field__manifest">
            <div className="button-field">
              <Button
                onClick={() => onClickItem(item)}
                title={dimensions.width < 1280 ? "Manifest" : "View Manifest"}
                isModal={true}
                targetValue="#manifest_modal"
              />
            </div>
          </Grid>
          <Grid item className="field__ledger">
            <div className="button-field">
              <Button
                onClick={() => onClickItem(item)}
                title={dimensions.width < 1280 ? "Ledger" : "View Ledger"}
                isModal={true}
                targetValue="#list_user_token_ledgers"
              />
            </div>
          </Grid>
          <Grid className="flex-center field__manager">
            <p className="status-field">
              {agencies.length
                ? currentAgency
                  ? currentAgency.username
                  : ""
                : item.category || ""}
            </p>
          </Grid>
          <Grid className="flex-center field__access">
            <p className="status-field">{getStatus()}</p>
          </Grid>
          <Grid item className="flex-center field__type">
            <p className="status-field">
              {item.user_access
                ? (
                    user_access.find(
                      (access) => access.value === item.user_access
                    ) || {}
                  ).label || ""
                : user_access.find((access) => access.value === "Member").label}
            </p>
          </Grid>
          {/* <p className="status-field">
          {item.friends ? "Limited access" : "Full access"}
        </p> */}
          <Grid item className="flex-center field__uid">
            <p className="uid-value" onClick={() => onCopyUID(item.id)}>
              {item.id}
            </p>
          </Grid>
          {/* <p
            className="member-close"
            data-toggle="modal"
            data-target="#remove_user"
            onClick={() => {
              // onRemoveUser(item);
              console.log("remove----", item);
            }}
          >
            <img src={remove_icon} className="remove-icon" alt="remove" />
          </p> */}
        </Grid>
      </div>
    );
  }
);

const Users = () => {
  const [loading, setLoading] = useState(false);
  const [brandData, setBrandData] = useState({});
  const [brand, setBrand] = useState(null);
  const [communityMembers, setCommunityMembers] = useState([]);
  const [allMembers, setAllMembers] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const [selectedUser, setSelectedUser] = useState({});
  const [selectedTicket, setSelectedTicket] = useState({});
  const [categories, setCategories] = useState([]);
  const [selectedPDF, setSelectedPDF] = useState("");
  const [agencies, setAgencies] = useState([]);
  const [agencyData, setAgencyData] = useState({});
  const [role, setRole] = useState(null);
  const [username, setUserName] = useState("");
  const [deleteUser, setDeleteUser] = useState({});
  const [isRefreshing, setIsRefreshing] = useState("");
  // const [selectedCategory, setSelectedCategory] = useState("");
  const [addTokenState, setAddTokenState] = useState(0);
  // the following 2 states below are associated with infinite scroll
  const [hasMore, setHasMore] = useState(true);
  const [lastSnapshot, setLastSnapshot] = useState(null);
  const [query, setQuery] = useState({
    full: false,
    pending: false,
    light: false,
    inactive: false,
    referred: false,
    search: "",
    category: "",
  });
  // const debouncedSearchKey = useDebounce(searchKey, 500);
  const [totalToken, setTotalToken] = useState({
    shopping_total: 0,
    premier_total: 0,
  });
  const [current, setCurrent] = useState("user");
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const manifestModalRef = useRef();

  useEffect(() => {
    if (!location.state) {
      history.push("/");
    } else {
      const { brand, role, username } = location.state;
      setRole(role);
      setBrand(brand);
      setUserName(username);
      setLoading(true);

      const uid = localStorage.getItem("uid");

      if (uid) {
        Firebase.getAgencyData(uid, (res) => {
          // console.log("agency", res);
          setAgencyData(res);
        });
      }
    }
  }, [location, isRefreshing]);
  useEffect(() => {
    function loadUser() {
      Firebase.getBrandDataByID(brand, async (brand_data) => {
        if (brand_data) {
          // const temp = await Firebase.getAllUsersInBrand("WeShare");
          // const ptuser = temp
          //   .map(async (t) => {
          //     const phistory = await Firebase.getPremierTokensHistory(
          //       "Vet Coin",
          //       t.uid
          //     );
          //     return phistory;
          //   })
          //   .filter((p) => p.length > 0);
          // Promise.all(ptuser).then((res) => {
          //   console.log("-=-=-=-=-", res);
          // });

          user_access[
            user_access.findIndex(
              (access) => access.value === "Brandname employee"
            )
          ] = {
            value: "Brandname employee",
            label: `Member - ${brand_data.name} employee`,
          };
          user_access[
            user_access.findIndex(
              (access) => access.value === "Friend of brandname"
            )
          ] = {
            value: "Friend of brandname",
            label: `Member - Friend of ${brand_data.name}`,
          };

          const filters =
            !agencyData ||
            !["Sales manager", "Sales rep"].includes(agencyData.type)
              ? {}
              : {
                  accountant: agencyData.uid,
                };

          const { users, snapshot } = await Firebase.getPaginatedUsers(
            brand_data.name,
            undefined,
            filters
          );
          // const users = await Firebase.getAllUsersInBrand(brand_data.name);
          setLastSnapshot(snapshot);
          setAllMembers(users);
          // const csvPromises = users.map(async (user) => {
          //   const token_history = await Firebase.getTokenSpentHistoryPromise(
          //     brand_data.name,
          //     user.id
          //   );
          //   const shopping_total = token_history.reduce(
          //     (n, { amount }) => n + amount,
          //     0
          //   );
          //   const premier_history = await Firebase.getPremierTokensHistory(
          //     brand_data.name,
          //     user.id
          //   );
          //   const premier_total = premier_history.reduce(
          //     (n, { amount }) => n + amount,
          //     0
          //   );
          //   return {
          //     name: user.firstname,
          //     internalID: user.internal_id || "",
          //     uid: user.id,
          //     category: user.category || "",
          //     referralID: user.referralCode || "",
          //     userType: user.phonenumber ? "Full user" : "Light user",
          //     access: user.user_access || "Member",
          //     premierTokens: -premier_total,
          //     shoppingTokens: -shopping_total,
          //   };
          // });
          // const csv = await Promise.all(csvPromises);
          // setCsvData(csv);
          setBrandData(brand_data);
          const uid = localStorage.getItem("uid");
          // Firebase.getAgencyData(uid, (res) => {
          let filteredData =
            !agencyData ||
            !["Sales manager", "Sales rep"].includes(agencyData.type)
              ? users
              : users.filter((user) => user.accountant === uid);
          filteredData = sortAlphabetically(filteredData);

          setCommunityMembers(filteredData);
          setCategories(brand_data.userCategories || []);
          setLoading(false);
          dispatch(saveBrand(brand_data));
        }
      });
    }
    if (agencyData) {
      loadUser(agencyData);
    }
  }, [agencyData]);
  useEffect(() => {
    const { brand } = location.state;
    Firebase.getAgencyByBrandID(brand, (res) => {
      setAgencies(
        res.filter((item) =>
          [
            "Sales manager",
            "Account manager",
            "Sales rep",
            "Service manager",
            "Service rep",
          ].includes(item.type)
        )
      );
    });
  }, []);
  // TODO: Below is commented-out while refactoring search on /users
  // useEffect(() => {
  //   setQuery({ ...query, search: debouncedSearchKey });
  // }, [debouncedSearchKey]);
  useEffect(() => {
    // setHasMore(true);
    let filteredResult = _.cloneDeep(allMembers);
    // TODO: Below is commented-out as we work through improving the /users page
    // if (query.search) {
    //   filteredResult = filteredResult.filter(
    //     (member) =>
    //       (member.firstname &&
    //         member.firstname
    //           .toLowerCase()
    //           .startsWith(query.search.toLowerCase())) ||
    //       (member.id &&
    //         member.id.toLowerCase().startsWith(query.search.toLowerCase())) ||
    //       (member.phonenumber && member.phonenumber.startsWith(query.search)) ||
    //       (member.internal_id &&
    //         member.internal_id
    //           .toLowerCase()
    //           .startsWith(query.search.toLowerCase()))
    //   );
    // }
    // if (query.category) {
    //   filteredResult = filteredResult.filter(
    //     (member) => member.category === query.category
    //   );
    // }
    let fullMember = [];
    let pendingMember = [];
    let lightMember = [];
    let inactiveMember = [];
    let referredUser = [];
    if (query.full) fullMember = filteredResult.filter((i) => i.eco_id);
    if (query.pending)
      pendingMember = filteredResult.filter((i) => i.phonenumber && !i.eco_id);
    if (query.light) lightMember = filteredResult.filter((i) => !i.phonenumber);
    if (query.inactive)
      inactiveMember = filteredResult.filter((i) => i.status === "Pending");
    if (query.referred) {
      referredUser = filteredResult.filter(
        (u) =>
          u.user_access === "Referred prospect" ||
          u.user_access === "Pending member"
      );
    }
    const uid = localStorage.getItem("uid");
    if (
      query.full ||
      query.pending ||
      query.lightMember ||
      query.inactive ||
      query.referred
    ) {
      const users = [
        ...fullMember,
        ...pendingMember,
        ...lightMember,
        ...inactiveMember,
        ...referredUser,
      ];
      let queriedUsers =
        !agencyData || !["Sales manager", "Sales rep"].includes(agencyData.type)
          ? users
          : users.filter((user) => user.accountant === uid);
      queriedUsers = sortAlphabetically(queriedUsers);

      setCommunityMembers(queriedUsers);
    } else {
      let queriedUsers =
        !agencyData || !["Sales manager", "Sales rep"].includes(agencyData.type)
          ? filteredResult
          : filteredResult.filter((user) => user.accountant === uid);
      queriedUsers = sortAlphabetically(queriedUsers);

      setCommunityMembers(queriedUsers);
    }
  }, [query, allMembers, agencyData]);
  const onSearch = async (e) => {
    e.preventDefault();

    if (!searchKey.trim()) return;

    setLastSnapshot(null);
    setHasMore(false);
    // setQuery({ ...query, search: searchKey.toLowerCase() }); // FIXME: disabled for now while refactoring search
    const searchResult = await Firebase.getUsersOnSearch(
      brandData.name,
      searchKey
    );
    setAllMembers(searchResult ? searchResult : []);

    // const filtered = allMembers.filter(
    //   (item) =>
    //     item.firstname &&
    //     item.firstname.toLowerCase().includes(searchKey.toLowerCase())
    // );
    // setCommunityMembers([...filtered]);
  };
  const clickItem = useCallback((item) => {
    // console.log("clicked user", item);
    setSelectedUser(item);
  });
  const copyText = useCallback((uid) => {
    document.getElementById("notify").click();
    let brandname = brandData.name.replace(/\s/g, "");
    let value = "https://ecosystem.life/" + brandname + "?uid=" + uid;
    navigator.clipboard.writeText(value);
  });

  const copyUID = useCallback((uid) => {
    document.getElementById("notify").click();
    navigator.clipboard.writeText(uid);
  });
  const onRemoveUser = useCallback(async () => {
    setLoading(true);
    await Firebase.removeCommunityMember(deleteUser.id, brandData.name);
    Firebase.getReferralsByBrand(brandData.name, (referrals) => {
      const deleteID = referrals.find(
        (ref) => ref.referredID === deleteUser.id
      );
      if (deleteID) {
        Firebase.deleteReferral(brandData.name, deleteID);
      }
    });
    setLoading(false);
    setAllMembers(allMembers.filter((member) => member.id !== deleteUser.id));
    manifestModalRef.current.close();
    //this.loadUser();
  });
  const addTokens = async (payload) => {
    setAddTokenState((prev) => prev + 1);
    if (!selectedUser) return;

    const { premierTokens, shoppingTokens, category, adminId } = payload;
    const tokenNum = parseInt(shoppingTokens, 10);
    if (premierTokens) {
      addPremierTokens(
        premierTokens,
        category.label ? category.label : category,
        adminId
      );
    }
    if (shoppingTokens) {
      let data = {
        created: new Date(),
        amount: -tokenNum,
        type: category.label ? category.label : category,
      };

      if (adminId) data.assignedBy = adminId;

      await Firebase.saveTokenSpentHistory(
        brandData.name,
        selectedUser.id,
        data
      );
      await Firebase.updateUserData(brandData.name, selectedUser.id, {
        tokens: (selectedUser.tokens || 0) + tokenNum,
      });
    }
  };
  const addPremierTokens = async (amount, type, adminId) => {
    let data = {
      created: new Date(),
      amount: -amount,
      type: type,
      environment: "production",
    };

    if (adminId) data.assignedBy = adminId;

    await Firebase.savePremierTokenHistory(
      brandData.name,
      selectedUser.id,
      data
    );
  };
  const addCommunityMember = async (firstname, phonenumber) => {
    try {
      setLoading(true);
      let user = await Firebase.addCommunityMember(
        {
          phonenumber,
          firstname,
          userstatus: "Pending",
        },
        brandData.name
      );
      let bespokeUrl = brandData.bespokeUrl
        ? brandData.bespokeUrl
        : `https://ecosystem.life/${brandData.name}?uid=${user.id}`;
      let response = await inviteUserSMS(
        phonenumber,
        brandData.smsSender || brandData.name,
        firstname,
        bespokeUrl
      );
      setLoading(false);
      setAllMembers([
        ...allMembers,
        {
          phonenumber,
          firstname,
          userstatus: "Pending",
          id: user.id,
        },
      ]);
    } catch (e) {
      alert(e.message);
    }
  };
  const schedule = async (option) => {
    const { description, duration, time, title, date } = option;
    const { hh, mm } = time;
    const minutes = hh * 60 + mm;
    let m = moment(date).set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
    const scheduled_time = m.add(minutes, "minutes");
    let task = {
      brand: brandData.name,
      options: {
        user: selectedUser,
        title,
        description,
        duration,
        selectedTicket,
      },
      performAt: scheduled_time.toDate(),
      status: "scheduled",
      worker: "makeCall",
    };
    try {
      await Firebase.addTask(task);
      const { firstname, phonenumber } = selectedUser;
      if (phonenumber)
        alertAppointment(
          phonenumber,
          brand,
          firstname,
          getDayStr(scheduled_time.toDate())
        );
      // addAppointment(scheduled_time.toDate().toString());
    } catch (error) {
      console.log("error", error);
    }
  };
  const handleChangeProfile = async ({ brandChanges, ecoChanges }) => {
    const { eco_id } = selectedUser;
    console.log("-=--=-==-", selectedUser, brandChanges, ecoChanges);
    if (ecoChanges) {
      if (eco_id) {
        await Firebase.updateEcoUser(eco_id, ecoChanges); //if eco user then update eco data
      } else {
        await Firebase.updateUserData(
          brandData.name,
          selectedUser.id,
          ecoChanges
        ); // update user data
      }
    }
    if (brandChanges) {
      await Firebase.updateUserData(
        brandData.name,
        selectedUser.id,
        brandChanges
      );
    }
    setIsRefreshing(Math.random());
  };
  const handleClickTicket = (ticket) => {
    setSelectedTicket(ticket);
  };
  const handleClickCategory = (category) => {
    // setSelectedCategory(category);
    setQuery({ ...query, category });
  };
  const handleClickAttachment = (content) => {
    const { media_type, media_url } = content;
    console.log("media_url", media_url);
    if (media_type === "pdf_file") setSelectedPDF(media_url);
  };
  const handleFilter = (filterSet) => () => {
    setQuery({ ...query, [filterSet]: !query[filterSet] });
  };
  const handleAddLightUser = (user) => {
    console.log("new USer:", user);
    setAllMembers([...allMembers, user]);
  };

  const handleExportDB = async (event, done) => {
    setLoading(true);
    console.log("🚀 ~ ============start");
    const csvPromises = allMembers.map((user) => {
      return {
        firstname: user.firstname,
        userType: user.user_access
          ? user_access.find((access) => access.value === user.user_access)
              .label
          : user_access.find((access) => access.value === "Member").label,
        category: user.category || "",
        accountManager: user.accountant || "N/A",
        leadInternalID: user.internal_id || "",
        uid: user.id,
        ecosystemMagicLink: brandData.bespokeUrl
          ? `${brandData.bespokeUrl}?uid=${user.id}`
          : `https://ecosystem.life/${brandData.name}?uid=${user.id}`,
      };
    });
    console.log("🚀 ~ ============await");
    // const csv = await Promise.all(csvPromises);
    Promise.all(csvPromises)
      .then((csv) => {
        setLoading(false);
        setCsvData(csv);
        done(true);
        console.log("🚀 ~ ============");
      })
      .catch((err) => {
        console.log("🚀 ~ ============error", err);
        setLoading(false);
        done(false);
      });
  };
  const getCsvData = () => {
    console.log("🚀 ~ file: index.js:504 ~ getCsvData ~ csvData:", csvData);
    return csvData;
  };
  const handleImportUsers = async () => {
    setLoading(true);
    const uploadPromise = usersJson
      .slice(0, 2000)
      // .filter(
      //   (u) =>
      //     allMembers.filter((member) => member.firstname === u["First Name"])
      //       .length === 0
      // )
      .map(async (jsonUser) => {
        const user = {
          firstname: jsonUser["First Name"],
          user_access: user_access.find(
            (type) => type.label === jsonUser["User Type"]
          ).value,
          category: jsonUser["User Categorisation"],
          accountant:
            jsonUser["Account Manager"] === "N/A"
              ? null
              : agencies.findIndex(
                  (agency) =>
                    agency.username ===
                    jsonUser["Account Manager"].split(" ")[0]
                ) < 0
              ? null
              : agencies.find(
                  (agency) =>
                    agency.username ===
                    jsonUser["Account Manager"].split(" ")[0]
                ).uid,
          internal_id: jsonUser["Lead Internal ID"],
        };
        const res = await Firebase.addLightUser(brandData.name, user);
        return res;
      });
    Promise.all(uploadPromise)
      .then((res) => {
        console.log("------done--------", res.length);
        setLoading(false);
      })
      .catch((err) => {
        console.log("err", err);
        setLoading(false);
      });
  };
  const getNameField = (member) => {
    return member.firstname || member.firstname === ""
      ? "firstname"
      : member.fistName || member.firstName === ""
      ? "firstName"
      : undefined;
  };
  const sortAlphabetically = (communityMembers) => {
    // sort array by first name
    communityMembers.sort((a, b) => {
      // FIXME: need to compensate here for inconsistent DB field naming. We should standardise them
      const aName = getNameField(a);
      const bName = getNameField(b);

      // Check if aName/bName is an empty string, starts with a number or is undefined and move to the end
      if (!aName || a[aName] === "" || /^\d/.test(a[aName])) {
        return 1;
      }
      if (!bName || b[bName] === "" || /^\d/.test(b[aName])) {
        return -1;
      }
      if (a[aName].toLowerCase() < b[bName].toLowerCase()) {
        return -1;
      }
      if (a[aName].toLowerCase() > b[bName].toLowerCase()) {
        return 1;
      }
      return 0;
    });
    return communityMembers;
  };
  const fetchMoreData = async () => {
    const filters = setDBFilters();

    const { users, snapshot } = await Firebase.getPaginatedUsers(
      brandData.name,
      lastSnapshot,
      filters
    );

    setTimeout(() => {
      setCommunityMembers([...communityMembers, ...users]);
      setLastSnapshot(snapshot);
    }, 800);
    // if no more returned documents
    if (!users.length) setHasMore(false);
  };
  const showEndMessage = () => {
    const style = { textAlign: "center", padding: "34px 0" };
    if (communityMembers.length < 26) return null;
    return <p style={style}>You are all set!</p>;
  };
  const showLoader = () => {
    const style = {
      backgroundColor: "transparent",
      position: "relative",
      padding: "18px 0",
    };
    return !loading && communityMembers.length > 24 ? (
      <div className="loading_gif" style={style}>
        <i className="fa fa-2x fa-sync fa-spin text-muted" />
      </div>
    ) : null;
  };
  const setDBFilters = () => {
    // sets filters for querying DB
    return !agencyData ||
      !["Sales manager", "Sales rep"].includes(agencyData.type)
      ? {}
      : {
          accountant: agencyData.uid,
        };
  };
  const handleInputChange = async (target) => {
    setSearchKey(target.value);

    if (!loading && !target.value.trim()) {
      setHasMore(true);
      const filters = setDBFilters();
      const { users, snapshot } = await Firebase.getPaginatedUsers(
        brandData.name,
        undefined,
        filters
      );
      setAllMembers(users);
      setLastSnapshot(snapshot);
    }
  };
  return (
    <div id="page-container">
      {loading && (
        <div className="loading_gif">
          <i className="fa fa-4x fa-sync fa-spin text-muted" />
        </div>
      )}
      <Header
        username={username}
        role={role}
        logo={brandData.logo}
        brand={brand}
        brandName={brandData.name}
        is_property_brand={brandData.is_property_brand}
        setHasMore={setHasMore}
      />
      <main
        id={
          window.location.pathname === "/users"
            ? "main-container--fixed"
            : "main-container"
        }
      >
        <div className="user-content__container">
          <div
            className={`user-content ${
              window.location.pathname === "/users"
                ? "user-content--fixed"
                : "'"
            }`}
          >
            <div>
              <div
                className={`member-row ${
                  window.location.pathname === "/users"
                    ? "member-row--fixed"
                    : ""
                }`}
              >
                {brandData && brandData.is_fulluser_creatable && (
                  <Button
                    title="Add a full member"
                    isModal={true}
                    targetValue="#add_community_member"
                  />
                )}
                {brandData &&
                  (brandData.is_lightuser_creatable ||
                    brandData.is_lightuser_creatable === undefined) && (
                    <Button
                      title="Add a light member"
                      isModal={true}
                      targetValue="#add_demo_user"
                    />
                  )}
                <form className="search-box" onSubmit={onSearch}>
                  <input
                    placeholder="Search for UID, Cell or InternaliD"
                    type="text"
                    value={searchKey}
                    onChange={({ target }) => handleInputChange(target)}
                    name="search"
                    autoComplete="off"
                    aria-autocomplete="none"
                  />
                  <button onClick={onSearch}>
                    <i className="fa fa-search" />
                  </button>
                </form>
                {/* {categories.length > 12 && (
                  <UserCategories
                    categories={categories}
                    // selectedCategory={selectedCategory}
                    onClick={handleClickCategory}
                    hex={brandData.hex}
                  />
                )} */}
                {/* <div className="setting-pannel">
                  <Button
                    title="Full users"
                    onClick={handleFilter("full")}
                    active={query.full}
                  />
                  <Button
                    title="Pending users"
                    onClick={handleFilter("pending")}
                    active={query.pending}
                  />
                  <Button
                    title="Light users"
                    onClick={handleFilter("light")}
                    active={query.light}
                  />
                  <Button
                    title="Referred users"
                    onClick={handleFilter("referred")}
                    active={query.referred}
                  />
                  <Button
                    title="Inactive users"
                    onClick={handleFilter("inactive")}
                    active={query.inactive}
                  />
                </div> */}
                {/* <CSVLink
                  asyncOnClick={true}
                  data={csvData}
                  headers={csvHeaders}
                  filename={`${
                    brandData.name
                  } customer database ${moment().format("MM-DD-YYYY")}.csv`}
                  className="btn btn-white btn-brand-hex"
                  onClick={handleExportDB}
                  style={{
                    "--hover-color": brandData.hex,
                    "--hover-text-color": brandData.hex
                      ? idealTextColor(brandData.hex)
                      : "black",
                  }}
                >
                  Download database
                </CSVLink> */}
                {/* <button className="btn btn-white" onClick={handleImportUsers}>
                  Import Users
                </button> */}
              </div>
              {/* {categories.length <= 12 && (
                <UserCategories
                  categories={categories}
                  // selectedCategory={selectedCategory}
                  onClick={handleClickCategory}
                  hex={brandData.hex}
                />
              )} */}
              <div className="member-row header-row">
                <Grid
                  container
                  style={{
                    flexWrap: "nowrap",
                    justifyContent: "space-between",
                  }}
                >
                  <Grid item className="header-row__name">
                    <p className="profile-field">Members</p>
                  </Grid>
                  <Grid item className="header-row__manifest">
                    <p className="button-field button-field__manifest">
                      Full Data
                    </p>
                  </Grid>
                  <Grid item className="header-row__ledger">
                    <p className="button-field">Tokens</p>
                  </Grid>
                  <Grid item className="header-row__manager">
                    <p className="status-field">
                      {agencies.length ? "Agent/Manager" : "Category"}
                    </p>
                  </Grid>
                  <Grid item className="header-row__access">
                    <p className="setting-field">User Access</p>
                  </Grid>
                  <Grid item className="header-row__type">
                    <p className="setting-field">User Type</p>
                  </Grid>
                  {/* <p className="status-field">Access</p> */}
                  <Grid item className="header-row__uid">
                    <p className="uid-field">UID</p>
                  </Grid>
                  {/* <Grid item xs={2}>
                    <p className="member-close"></p>
                  </Grid> */}
                </Grid>
              </div>
              <InfiniteScroll
                className="infinite-scroll-container"
                dataLength={communityMembers.length}
                next={fetchMoreData}
                hasMore={hasMore}
                loader={showLoader()}
                endMessage={showEndMessage()}
              >
                {communityMembers.map((item, i) => (
                  <Fragment key={i}>
                    <UserItem
                      item={item}
                      onClickItem={clickItem}
                      onCopyText={copyText}
                      onCopyUID={copyUID}
                      onRemoveUser={setDeleteUser}
                      agencies={agencies}
                    />
                  </Fragment>
                ))}
              </InfiniteScroll>
              {!loading && communityMembers.length === 0 ? (
                <p style={{ textAlign: "center", marginTop: "50px" }}>
                  Sorry, we couldn't find any members for your query.
                </p>
              ) : null}
            </div>
          </div>
        </div>
      </main>
      <AddCommunityMemberModal addUser={addCommunityMember} />
      {brandData.name && (
        <Fragment>
          <AddDemoUserModal brandData={brandData} onAdd={handleAddLightUser} />
          <UserTokenLedgerModal
            user={selectedUser}
            brandName={brandData.name}
            territory={brandData.territory}
            addTokenState={addTokenState}
            setTotal={setTotalToken}
            current={current}
            setCurrent={setCurrent}
            white={brandData.white}
            hex={brandData.hex}
            adminType={agencyData.type}
          />
          <AddTokenLedgerModal
            user={selectedUser}
            {...brandData}
            addTokens={addTokens}
            total={totalToken}
            setCurrent={setCurrent}
          />
          <ManifestModal
            user={selectedUser}
            brandData={brandData}
            categories={categories}
            isChatCRMNotVisible={
              brandData &&
              brandData.permissions &&
              !brandData.permissions.concierge &&
              !brandData.permissions.tickets &&
              !brandData.permissions.newchat
            }
            onChangeProfile={handleChangeProfile}
            onClickTicket={handleClickTicket}
            onClickAttachment={handleClickAttachment}
            removeUser={setDeleteUser}
            ref={manifestModalRef}
          />
          <PDFViewerModal pdfUrl={selectedPDF} />
          <AddNoteModal
            brandData={brandData}
            roomId={selectedUser.id}
            uid={localStorage.getItem("uid")}
            ticket={selectedTicket}
            username={username}
            onChangeProfile={handleChangeProfile}
            addTokens={addTokens}
          />
          <ScheduleModal
            users={false}
            isDatePickable={true}
            schedule={schedule}
          />
          <ConfirmationModal
            title="Are you sure you want to remove this user?"
            id="remove_user"
            onClick={onRemoveUser}
            hex={brandData.hex}
            white={brandData.white}
          />
        </Fragment>
      )}
    </div>
  );
};

export default Users;



// WEBPACK FOOTER //
// ./src/screens/Users/index.js